<template>
  <div class="at-infobox mt-0 px-4">
    <div class="form-group mb-5">
      <span class="text-white d-block heading-2">M3U8 Live TV Lists</span>
      <el-radio v-model="liveTv" :label="true" class="mt-3">
        1-AXETV
      </el-radio>
    </div>

    <div class="form-group mb-5">
      <span class="text-white d-block heading-2">Default App Language</span>
      <el-radio v-model="language" label="en" class="mt-3" 
        @change="update('language')"
      >
        English
      </el-radio>
      <el-radio v-model="language" label="es" class="mt-3" 
        @change="update('language')"
      >
        Español
      </el-radio>
    </div>

    <div class="form-group mb-5">
      <span class="text-white d-block heading-2">Stream Format</span>
      <el-radio v-model="stream_format" label="m3u8" class="mt-3" 
        @change="update('stream_format')"
      >
        HLS
      </el-radio>
      <el-radio v-model="stream_format" label="ts" class="mt-3" 
        @change="update('stream_format')"
      >
        TS
      </el-radio>
    </div>

    <div class="form-group mb-5">
      <span class="text-white d-block heading-2">Audio Language</span>
      <el-radio v-model="audio_language" label="english" class="mt-3" 
        @change="update('audio_language')"
      >
        English
      </el-radio>
      <el-radio v-model="audio_language" label="spanish" class="mt-3" 
        @change="update('audio_language')"
      >
        Spanish
      </el-radio>
    </div>

    <div class="form-group mb-5">
      <span class="text-white d-block heading-2">Subtitle Language</span>
      <el-radio v-model="subtitle_language" label="english" class="mt-3" 
        @change="update('subtitle_language')"
      >
        English
      </el-radio>
      <el-radio v-model="subtitle_language" label="spanish" class="mt-3" 
        @change="update('subtitle_language')"
      >
        Spanish
      </el-radio>
      <el-radio v-model="subtitle_language" label="off" class="mt-3" 
        @change="update('subtitle_language')"
      >
        Off
      </el-radio>
    </div>

    <div class="form-group">
      <span class="text-white d-block heading-2 mb-3">
        Used Mac Address
      </span>

      <div class="alert alert-secondary alert-dark mt-3" v-if='macAddresses.length < 1'>
        No mac address exists
      </div>
      
      <div class='mac-addr' v-for="(mac, k) in macAddresses" :key=k>
        <span><strong>MacAddress:</strong> {{ mac.mac_address }}</span>
        <span><strong>Device:</strong> {{ mac.device_name }}</span>
        <span><strong>IP:</strong> {{ mac.ip_address }}</span>
      </div>

      <button class="btn btn-secondary btn-sm mt-2" @click="clearMac()"
        v-if='macAddresses.length > 0'
      >
        Clear Mac Address
      </button>
    </div>

  </div>
</template>



<script>
import { authRequest } from '../../app/helpers';
import toastr from 'toastr';

export default {
  data() {
    return {
      liveTv: true,
      language: '',
      stream_format: '',
      audio_language: '',
      subtitle_language: '',
      macAddresses: [],
    }
  },


  mounted() {
    this.getSettings();
  },


  methods: {
    async getSettings() {
      const req = await authRequest(
        this.$router,
        '/user/site_settings'
      );

      const reqKeys = Object.keys(req);

      for (const i in reqKeys) {
        const element = reqKeys[i];
        
        this.$data[element] = req[element];
      }
    },

    async update(option) {
      const value = this.$data[option];

      const req = await authRequest(
        this.$router, 
        '/user/site_setting/' + option, 
        { value }, 
        'post'
      );

      if (req.status) {
        toastr.success(req.message);
      } else {
        toastr.error(req.message);
      }
    },


    async clearMac() {
      const req = await authRequest(
        this.$router, 
        '/user/clear_mac', 
        {}, 
        'delete'
      );

      if (req.status) {
        toastr.success(req.message);
        this.macAddresses = [];
      } else {
        toastr.error(req.message);
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.el-radio__label {
  font-size: 15px;
  font-weight: 600;
}

.mac-addr > span {
    display: block;
    color: #e8e8e8;
}

.mac-addr {
    margin-bottom: 20px;
}
</style>